
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMoveItemIn as ObiMoveItemInElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-move-item-in.js';
 
 
 

 
 export const ObiMoveItemIn = createComponent({
   react: React,
   tagName: 'obi-move-item-in',
   elementClass: ObiMoveItemInElement,
   events: {
     
   }
  });
 
 